var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7C6.5911 7 6.22339 7.24895 6.07152 7.62861L4.07152 12.6286C4.02428 12.7467 4 12.8728 4 13V19C4 19.5523 4.44772 20 5 20H6.17071C6.58254 21.1652 7.69378 22 9 22C10.3062 22 11.4175 21.1652 11.8293 20H16.1707C16.5825 21.1652 17.6938 22 19 22C20.3062 22 21.4175 21.1652 21.8293 20H23C23.5523 20 24 19.5523 24 19V15C24 13.3431 22.6569 12 21 12H20.4806L16.7809 7.3753C16.5911 7.13809 16.3038 7 16 7H7ZM21.8293 18H22V15C22 14.4477 21.5523 14 21 14H6V18H6.17071C6.58254 16.8348 7.69378 16 9 16C10.3062 16 11.4175 16.8348 11.8293 18H16.1707C16.5825 16.8348 17.6938 16 19 16C20.3062 16 21.4175 16.8348 21.8293 18ZM18 19C18 18.4477 18.4477 18 19 18C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20C18.4477 20 18 19.5523 18 19ZM10 19C10 18.4477 9.55228 18 9 18C8.44772 18 8 18.4477 8 19C8 19.5523 8.44772 20 9 20C9.55228 20 10 19.5523 10 19ZM13 12H6.47703L7.67703 9H13V12ZM15 12V9H15.5194L17.9194 12H15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarTravel);
export default __webpack_public_path__ + "static/media/car-travel.4e9428798d94171003195de9043d07c9.svg";
export { ForwardRef as ReactComponent };